export default {
  origin: '',
  get root () {
    const defaultOrigin = 'https://wl.primeraplus.com.mx';
    const origin = this.origin || defaultOrigin;

    return `${origin}/api/v2/splus`;
  },
  signIn: 'login',
  signUp: 'register',
  signOut: 'logout',
  getProfile: 'profile',
  forgotPin: 'password_reset',
};



// WEBPACK FOOTER //
// ../config/apiConfig.js